/*
 * LoanJS
 * Calculating loan in equal installments
 * https://github.com/kfiku/LoanJS
 *
 * Copyright (c) 2014 Grzegorz Klimek
 * Licensed under the MIT license.
 *
 * Sep - 2020
 * Modified by Shri and Kyriacos to better suit our needs.
 * Also converted to Typescript
 */
const getNextInstallment = (amount, numberOfInstallments, interestRate, capitalSum, interestSum) => {
    let capital;
    let interest;
    let installment;
    let irmPow;
    const interestRateMonth = interestRate / 1200;
    // awning - added this change so we dont have nan when 100% down payment was made
    if (amount === 0) {
        return {
            capital: 0,
            interest: 0,
            installment: 0,
            remain: 0,
            interestSum: 0,
        };
    }
    irmPow = Math.pow(1 + interestRateMonth, numberOfInstallments);
    installment = amount * ((interestRateMonth * irmPow) / (irmPow - 1));
    interest = (amount - capitalSum) * interestRateMonth;
    capital = installment - interest;
    return {
        capital,
        interest,
        installment,
        remain: amount - capitalSum - capital,
        interestSum: interestSum + interest,
    };
};
export function loan(
/** loan amount (purchase - downPayment) */
amount, 
/** how many installments will be in months */
numberOfInstallments, 
/** interest rate in percent (3.5) equal/annuity (false) */
interestRate) {
    let installments = [];
    let yearlyInstallments = [];
    let interestSum = 0;
    let capitalSum = 0;
    let sum = 0;
    let i = 0;
    while (i < numberOfInstallments) {
        let monthlyInstallments = [];
        let j = 0;
        while (j < 12) {
            const inst = getNextInstallment(amount, numberOfInstallments, interestRate, capitalSum, interestSum);
            sum += inst.installment;
            capitalSum += inst.capital;
            interestSum += inst.interest;
            /** adding lost sum on rounding */
            if (i === numberOfInstallments - 1) {
                capitalSum += inst.remain;
                sum += inst.remain;
                inst.remain = 0;
            }
            monthlyInstallments.push(inst);
            j++;
            i++;
        }
        installments = [...installments, ...monthlyInstallments];
        yearlyInstallments = [...yearlyInstallments, getYearlyInstallment(monthlyInstallments)];
    }
    return {
        installments,
        yearlyInstallments,
        amount,
        interestSum,
        capitalSum,
        sum,
    };
}
function getYearlyInstallment(monthlyInstallments) {
    return monthlyInstallments.reduce((r, month) => {
        r.capital += month.capital;
        r.interest += month.interest;
        r.installment += month.installment;
        r.remain += month.remain;
        return r;
    }, {
        capital: 0,
        interest: 0,
        installment: 0,
        remain: 0,
    });
}
//# sourceMappingURL=loan.js.map